// src/pages/gt3x/OverviewSpecialX.jsx

export default function Overview() {
    const everett = { fontFamily: 'Everett, sans-serif' };

    return (
        <>
            {/* Einleitung */}
            <div className="card overview-card-top">
                <h1>Special Xperience – Overview</h1>
                <p style={{ marginBottom: "10px",
                    fontFamily: 'var(--ff-Everett), sans-serif',
                }}>
                    Willkommen in unserer iRacing Special Xperience!
                </p>
                <p>
                    Schön, dass du dabei bist. Auf dieser Seite findest du
                    die wichtigsten Ansprechpartner sowie die wichtigsten Informationen.
                </p>
            </div>

            {/* Verantwortliche */}
            <div className="card overview-card">
                <h2>Verantwortliche Personen</h2>

                <div className="fancyTable">
                    <table className="tbl-overview-table">
                        <thead>
                        <tr>
                            <th className="align-left">Bereich</th>
                            <th className="align-left">Verantwortliche</th>
                        </tr>
                        </thead>
                        <tbody style={everett}>
                        <tr>
                            <td className="align-left"><strong>Orga</strong></td>
                            <td className="align-left">Michael Müller, Philipp Gerdellebracht
                            <br/> Chris Geserer, Patrick Valente Ferro</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Format */}
            <div className="card overview-card">
                <h2>Liga Format</h2>

                <div className="fancyTable">
                    <table className="tbl-overview-table">
                        <thead>
                        <tr>
                            <th className="align-left">Special Xperience</th>
                            <th className="align-left"></th>
                        </tr>
                        </thead>
                        <tbody style={everett}>
                        <tr>
                            <td className="align-left"><strong>Schedule</strong></td>
                            <td className="align-left">2 Wochen Rhythmus </td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Renndauer</strong></td>
                            <td className="align-left">siehe Rennkalender</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Qualifikation</strong></td>
                            <td className="align-left">Open Qualy</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Wertungen</strong></td>
                            <td className="align-left">Fahrerwertung</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Streichergebnisse</strong></td>
                            <td className="align-left">2x Einzelläufe</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Fahrzeugklasse</strong></td>
                            <td className="align-left">siehe Kalender</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Wetter</strong></td>
                            <td className="align-left">static - kein Regen<br/>
                            </td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Schaden</strong></td>
                            <td className="align-left">No Damage</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Startgebühr</strong></td>
                            <td className="align-left">keine</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Rennkommission</strong></td>
                            <td className="align-left">Da es sich in erster Linie um eine Fun Serie <br/>
                                handelt appellieren wir an <br/> gesunden Menschenverstand der Fahrer</td>
                        </tr>

                        </tbody>
                    </table>
                </div>
            </div>

            {/* Wochenüberblick */}
            <div className="card overview-card">
                <h2>Schedule</h2>

                {/* Dienstag */}
                <h3>Donnerstag – Renntag</h3>
                <div className="fancyTable" style={{ marginBottom: "22px" }}>
                    <table className="tbl-overview-table">
                        <thead>
                        <tr>
                            <th className="align-left">Session</th>
                            <th className="align-left">Zeit</th>
                        </tr>
                        </thead>
                        <tbody style={everett}>
                        <tr>
                            <td className="align-left"><strong>Serverstart</strong></td>
                            <td>19:00 Uhr</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Practice (40 Min)</strong></td>
                            <td>19:00 – 19:40 Uhr</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Open Qualifying (15 Min)</strong></td>
                            <td>19:40 – 19:55 Uhr</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Warmup (5 Min)</strong></td>
                            <td>19:55 – 20:00 Uhr</td>
                        </tr>
                        <tr>
                            <td className="align-left"><strong>Race</strong></td>
                            <td>20:00 Uhr</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </>
    );
}
